import { Box, Link, Paper, Typography, Tooltip, useMediaQuery } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { POTENCIA_MINIMA_VERTICAL } from "src/components/projetos/constants";
import theme from "src/theme/light";

interface Item {
  id: string;
  title: string;
  subtitle?: string;
  isSelected?: boolean;
  onClick?: (id: string) => void;
  disable?: boolean;
}

interface CardProps extends Item {
  totalItems: number;
  handleClickOnMoreInformations: (e: any, id: string) => void;
}

interface CardsListProps {
  handleClickOnMoreInformations: (id: string) => void;
  selected?: string;
  items: Item[]
  onSelect?: (id: string) => void
}

interface StylesProps {
  totalItems: number;
  isSelected: boolean;
  isDisable: boolean;
  isMobile: boolean;
}

const useStyles = makeStyles({
  title: {
    fontWeight: 600,
    color: (props: StylesProps) => props.isDisable ? theme.palette.action.disabled : theme.palette.primary.dark
  },
  subtitle: {
    fontWeight: 600,
    color: (props: StylesProps) => props.isDisable ? theme.palette.action.disabled : theme.palette.primary.dark
  },
  text: {
    fontSize: 14,
    fontWeight: 400,
    marginBottom: 0,
    paddingBottom: 0,
    color: theme.palette.action.disabled,
  },
  container: {
    cursor: 'pointer',
    marginBottom: (props: StylesProps) => props.isMobile ? "16px" : 0,
    width: (props: StylesProps) => props.isMobile ? "100%" : `calc(100% / ${props.totalItems} - 20px)`,
    background: (props: StylesProps) => props.isDisable ? theme.palette.action.disabledBackground : props.isSelected ? '#F2F8F4' : 'white',
  }
})


const Card = ({ id, isSelected = false, totalItems, title, subtitle, disable, handleClickOnMoreInformations, onClick }: CardProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const classes = useStyles({ totalItems, isSelected, isMobile, isDisable: disable || false});
  const cliente = id === 'cliente';

  return (
    <Tooltip title={disable ? "Ao editar um projeto, não é possível alterar o tipo de cliente" : ""}>
      <Paper onClick={onClick ? () => onClick(id) : undefined} elevation={1} className={classes.container}>
        <Box height='100%' display='flex' justifyContent={'space-between'} flexDirection="column" p={2} >
          <Typography className={classes.title} align="left" variant='h5'>{title}</Typography>
          <Typography className={classes.subtitle} align="left">{subtitle || ''}</Typography>
          <Typography className={classes.text} align="left">Serviço: { cliente ? `Disponível para projetos até ${POTENCIA_MINIMA_VERTICAL} kWp` : 'Não disponível'}</Typography>

          <Box mt={3} display='flex' justifyContent={'flex-start'}>
            <Link onClick={(e) => handleClickOnMoreInformations(e, id)} color="secondary">Mais informações</Link>
          </Box>
        </Box>
      </Paper>
    </Tooltip>
  )
}

const CardsList = ({ items, onSelect, handleClickOnMoreInformations, selected = undefined}: CardsListProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box flexDirection={isMobile ? "column" : "row"} display='flex' margin={"0 auto"} justifyContent='space-between'>
      {items.map((item, _, array) => (
        <Card
          totalItems={array.length}
          key={item.id}
          onClick={onSelect}
          isSelected={selected === item.id}
          id={item.id}
          title={item.title}
          subtitle={item.subtitle}
          disable={item.disable || false}
          handleClickOnMoreInformations={(e, id) => {
            e.stopPropagation()
            handleClickOnMoreInformations(id)
          }}
          />
      ))}
    </Box>
  )
}

export { CardsList }